export const PRESCRIPTION_LIST_REQUESTED = 'PRESCRIPTION_LIST_REQUESTED';
export const PRESCRIPTION_LIST_SUCCEED = 'PRESCRIPTION_LIST_SUCCEED';
export const PRESCRIPTION_LIST_FAILED = 'PRESCRIPTION_LIST_FAILED';

export const PRESCRIPTION_CREATE_REQUESTED = 'PRESCRIPTION_CREATE_REQUESTED';
export const PRESCRIPTION_CREATE_SUCCEED = 'PRESCRIPTION_CREATE_SUCCEED';
export const PRESCRIPTION_CREATE_FAILED = 'PRESCRIPTION_CREATE_FAILED';

export const PRESCRIPTION_GET_REQUESTED = 'PRESCRIPTION_GET_REQUESTED';
export const PRESCRIPTION_GET_SUCCEED = 'PRESCRIPTION_GET_SUCCEED';
export const PRESCRIPTION_GET_FAILED = 'PRESCRIPTION_GET_FAILED';

export const PRESCRIPTION_ORDER_GET_REQUESTED = 'PRESCRIPTION_ORDER_GET_REQUESTED';
export const PRESCRIPTION_ORDER_GET_SUCCEED = 'PRESCRIPTION_ORDER_GET_SUCCEED';
export const PRESCRIPTION_ORDER_GET_FAILED = 'PRESCRIPTION_ORDER_GET_FAILED';

export const PRESCRIPTION_DOCTOR_GET_REQUESTED = 'PRESCRIPTION_DOCTOR_GET_REQUESTED';
export const PRESCRIPTION_DOCTOR_GET_SUCCEED = 'PRESCRIPTION_DOCTOR_GET_SUCCEED';
export const PRESCRIPTION_DOCTOR_GET_FAILED = 'PRESCRIPTION_DOCTOR_GET_FAILED';

export const PRESCRIPTION_TEMPLATE_CREATE_REQUESTED = 'PRESCRIPTION_TEMPLATE_CREATE_REQUESTED';
export const PRESCRIPTION_TEMPLATE_CREATE_SUCCEED = 'PRESCRIPTION_TEMPLATE_CREATE_SUCCEED';
export const PRESCRIPTION_TEMPLATE_CREATE_FAILED = 'PRESCRIPTION_TEMPLATE_CREATE_FAILED';

export const PRESCRIPTION_TEMPLATES_GET_REQUESTED = 'PRESCRIPTION_TEMPLATE_GET_REQUESTED';
export const PRESCRIPTION_TEMPLATES_GET_SUCCEED = 'PRESCRIPTION_TEMPLATE_GET_SUCCEED';
export const PRESCRIPTION_TEMPLATES_GET_FAILED = 'PRESCRIPTION_TEMPLATE_GET_FAILED';

export const PRESCRIPTION_TEMPLATE_DELETE_REQUESTED = 'PRESCRIPTION_TEMPLATE_DELETE_REQUESTED';
export const PRESCRIPTION_TEMPLATE_DELETE_SUCCEED = 'PRESCRIPTION_TEMPLATE_DELETE_SUCCEED';
export const PRESCRIPTION_TEMPLATE_DELETE_FAILED = 'PRESCRIPTION_TEMPLATE_DELETE_FAILED';

export const PRESCRIPTION_TEMPLATE_UPDATE_REQUESTED = 'PRESCRIPTION_TEMPLATE_UPDATE_REQUESTED';
export const PRESCRIPTION_TEMPLATE_UPDATE_SUCCEED = 'PRESCRIPTION_TEMPLATE_UPDATE_SUCCEED';
export const PRESCRIPTION_TEMPLATE_UPDATE_FAILED = 'PRESCRIPTION_TEMPLATE_UPDATE_FAILED';

export const PRESCRIPTION_CONFIG_GET_REQUESTED = 'PRESCRIPTION_CONFIG_GET_REQUESTED';
export const PRESCRIPTION_CONFIG_GET_SUCCEED = 'PRESCRIPTION_CONFIG_GET_SUCCEED';
export const PRESCRIPTION_CONFIG_GET_FAILED = 'PRESCRIPTION_CONFIG_GET_FAILED';

export const PRESCRIPTION_CONFIG_PARSE_REQUESTED = 'PRESCRIPTION_CONFIG_PARSE_REQUESTED';
export const PRESCRIPTION_CONFIG_PARSE_SUCCEED = 'PRESCRIPTION_CONFIG_PARSE_SUCCEED';
export const PRESCRIPTION_CONFIG_PARSE_FAILED = 'PRESCRIPTION_CONFIG_PARSE_FAILED';

export const PRESCRIPTION_GET_PENDING_REQUESTED = 'PRESCRIPTION_GET_PENDING_REQUESTED';
export const PRESCRIPTION_GET_PENDING_SUCCEED = 'PRESCRIPTION_GET_PENDING_SUCCEED';
export const PRESCRIPTION_GET_PENDING_FAILED = 'PRESCRIPTION_GET_PENDING_FAILED';

export const PRESCRIPTION_VOID_REQUESTED = 'PRESCRIPTION_VOID_REQUESTED';
export const PRESCRIPTION_VOID_SUCCEED = 'PRESCRIPTION_VOID_SUCCEED';
export const PRESCRIPTION_VOID_FAILED = 'PRESCRIPTION_VOID_FAILED';

export const PRESCRIPTION_SEARCH_PRODUCT_REQUESTED = 'PRESCRIPTION_SEARCH_PRODUCT_REQUESTED';
export const PRESCRIPTION_SEARCH_PRODUCT_SUCCEED = 'PRESCRIPTION_SEARCH_PRODUCT_SUCCEED';
export const PRESCRIPTION_SEARCH_PRODUCT_FAILED = 'PRESCRIPTION_SEARCH_PRODUCT_FAILED';

export const PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_REQUESTED =
  'PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_REQUESTED';
export const PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_SUCCEED =
  'PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_SUCCEED';
export const PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_FAILED =
  'PRESCRIPTION_SEARCH_LIFEPACK_PRODUCT_FAILED';

export const PRESCRIPTION_GET_CLINICAL_TERM_REQUESTED = 'PRESCRIPTION_GET_CLINICAL_TERM_REQUESTED';
export const PRESCRIPTION_GET_CLINICAL_TERM_SUCCEED = 'PRESCRIPTION_GET_CLINICAL_TERM_SUCCEED';
export const PRESCRIPTION_GET_CLINICAL_TERM_FAILED = 'PRESCRIPTION_GET_CLINICAL_TERM_FAILED';

export const PRESCRIPTION_GET_OTTER_MEDICINE_REQUESTED =
  'PRESCRIPTION_GET_OTTER_MEDICINE_REQUESTED';
export const PRESCRIPTION_GET_OTTER_MEDICINE_SUCCEED = 'PRESCRIPTION_GET_OTTER_MEDICINE_SUCCEED';
export const PRESCRIPTION_GET_OTTER_MEDICINE_FAILED = 'PRESCRIPTION_GET_OTTER_MEDICINE_FAILED';

export const PRESCRIPTION_GET_DOCUMENT_TEMPLATES_REQUESTED =
  'PRESCRIPTION_GET_DOCUMENT_TEMPLATES_REQUESTED';
export const PRESCRIPTION_GET_DOCUMENT_TEMPLATES_SUCCEED =
  'PRESCRIPTION_GET_DOCUMENT_TEMPLATES_SUCCEED';
export const PRESCRIPTION_GET_DOCUMENT_TEMPLATES_FAILED =
  'PRESCRIPTION_GET_DOCUMENT_TEMPLATES_FAILED';

export const PRESCRIPTION_RESET = 'PRESCRIPTION_RESET';

export const PRESCRIPTION_GET_LIFEPACK_MEDICINE_REQUESTED =
  'PRESCRIPTION_GET_LIFEPACK_MEDICINE_REQUESTED';
export const PRESCRIPTION_GET_LIFEPACK_MEDICINE_SUCCEED =
  'PRESCRIPTION_GET_LIFEPACK_MEDICINE_SUCCEED';
export const PRESCRIPTION_GET_LIFEPACK_MEDICINE_FAILED =
  'PRESCRIPTION_GET_LIFEPACK_MEDICINE_FAILED';
